import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography } from '@mui/material';
import {
  MEDICINE_DOSE,
  MEDICINE_FREQUENCY,
  MEDICINE_NAME,
  MEDICINE_UNIT,
  OCCUPY_STATUS,
  YES_NO
} from '../../../../../constants';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useRef } from 'react';

export const IcdDiagnosisDetailsForm = ({ onAdd, onClose, icdDropdown }) => {
  const diagnosRef = useRef();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        add_diagnos: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmit = (formValue) => {
    onAdd(formValue);
    reset();
    if (diagnosRef.current) {
      diagnosRef.current.focus();
    }
  };

  useEffect(() => {
    if (diagnosRef.current) {
      diagnosRef.current.focus();
    }
  }, []);

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 1, marginLeft: '1%' }}>
        <Grid item>
          <Typography fontWeight="bold" fontSize="14px" color="red">
            Add ICD Diagnosis
          </Typography>
        </Grid>
        <SelectTag
          inputRef={diagnosRef}
          name="add_diagnos"
          menus={icdDropdown.map((data) => ({ ...data, name: data.diagnosis, _id: data.diagnosis }))}
        />
      </Grid>
      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
